import { Component, OnInit } from '@angular/core';
import { StorageService } from './core/cache/storage.service';
import { Constants } from './shared/utilities/constants';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  userData: any = null;

  constructor(private readonly storageService: StorageService) {}

  ngOnInit() {
    this.initializeLoginProcess();
  }

  initializeLoginProcess() {
    this.storageService.loginLogout.subscribe((value: string) => {
      this.userData = value === 'login' ? this.getToken() : null;
    });
  }

  getToken() {
    const token = localStorage.getItem(Constants.STORAGE_KEYS.ID_TOKEN);
    return token ? JSON.parse(token) : '';
  }
}
